import React from 'react';
import ChoiceGroup from '../../../../Forms/ChoiceGroup';
import TextField from '../../../../Forms/TextField';

const HomeOverviewForm = () => {
    const statOptions = [
        { key: 0, text: 'Off' },
        { key: 1, text: 'On' },
    ];

    return (
        <div className="mt-1">
            <p>For all images, enter URL with a 'https://cdn.igrad.com/' domain, formatted as .webp. You can convert them here if needed: https://cloudconvert.com/jpg-to-webp.</p>
            <TextField
                label="Checkup Image 1"
                inputProps={{ pattern: "https://cdn.igrad.com/__.webp" }}
                placeholder="Enter URL with 'https://cdn.igrad.com/'/' domain"
                type="text"
                name="homeOverviewCheckupImage1"
            />
            <TextField
                label="Personality Image 2"
                inputProps={{ pattern: "https://cdn.igrad.com/__.webp" }}
                placeholder="Enter URL with 'https://cdn.igrad.com/'/' domain"
                type="text"
                name="homeOverviewPersonalityImage2"
            />
            <TextField
                label="Progress Image 3"
                inputProps={{ pattern: "https://cdn.igrad.com/__.webp" }}
                placeholder="Enter URL with 'https://cdn.igrad.com/'/' domain"
                type="text"
                name="homeOverviewProgressImage3"
            />
            <ChoiceGroup label="Stats" name="showPlatformStatistics" options={statOptions} />
        </div>
    );
};

export default HomeOverviewForm;
